/*
 * 展商的路由文件
 */
export default [
  //个人中心
  {
    path: "/me/exhibition",
    meta: {
      title: "个人中心"
    },
    redirect: "/me/exhibition/vrbooth",
    component: () => import("@wenxing/pages/me/meLayout.vue"),
    children: [
      {
        name: "VR展台",
        path: "/me/exhibition/vrbooth",
        meta: {
          title: "VR展台"
        },
        component: () => import("@wenxing/pages/vrbooth/vrBooth")
      },
      {
        name: "我的线上展台",
        path: "/me/exhibition/vrboothPlan",
        meta: {
          title: "我的线上展台"
        },
        component: () => import("@wenxing/pages/vrbooth/vrboothPlan")
      },
      {
        name: "我的展品",
        path: "/me/exhibition/list",
        meta: {
          title: "我的展品"
        },
        component: () => import("@wenxing/pages/exhibition/exhibitList")
      },
      {
        name: "个人信息",
        path: "/me/exhibition/profile",
        meta: {
          title: "个人信息"
        },
        component: () => import("@wenxing/pages/exhibition/editInfo.vue")
      },
      {
        name: "个人收藏",
        path: "collectAndLike",
        meta: {
          title: "个人收藏"
        },
        component: () => import("@wenxing/pages/collectAndLikeExhibition/collectAndLikeExhibition")
      },
      //我的资料
      {
        name: "wenxing-pc-exhibition-center",
        path: "center",
        meta: {
          title: "个人中心-我的资料"
        },
        component: () => import("@wenxing/pages/exhibition/center")
      },
      /*
       * lokep
       * 我的展品 列表 详情 编辑
       */
      // dev 拉取
      {
        name: "展商我的消息",
        path: "/me/exhibition/message",
        meta: {
          title: "个人中心-我的消息"
        },
        component: () => import("@wenxing/pages/message/message")
      },
      {
        name: "展商我的直播",
        path: "liveList",
        meta: {
          title: "个人中心-我的直播"
        },
        component: () => import("@wenxing/pages/exhibition/liveList/liveList.vue")
      },
      {
        name: "我的直播详情",
        path: "liveList/:liveId",
        meta: {
          title: "我的直播详情"
        },
        component: () => import("@wenxing/pages/exhibition/liveList/showLiveDetail.vue")
      },
      {
        name: "展商发起我的直播",
        path: "modifyLiveDetail",
        meta: {
          title: "展商发起我的直播"
        },
        component: () =>
          import("@wenxing/pages/exhibition/liveList/modifyLiveDetail.vue")
      },
      {
        name: "我的预约",
        path: "reservation",
        meta: {
          title: "个人中心-我的预约"
        },
        component: () => import("@wenxing/pages/reservation/myReservation.vue")
      },
      {
        meta: {
          title: "我的日程"
        },
        name: "个人中心-我的日程",
        path: "schedule",
        component: () => import("@wenxing/pages/reservation/mySchedule.vue")
      },
      {
        name: "展商上传我的直播",
        path: "uploadLiveDetail",
        meta: {
          title: "展商上传我的直播"
        },
        component: () =>
          import("@wenxing/pages/exhibition/liveList/uploadLiveDetail.vue")
      },


      {
        name: "wenxing-pc-exhibition-exhibit-detail",
        path: "exhibit/detail/:id",
        meta: {
          title: "个人中心-展品详情"
        },
        component: () => import("@wenxing/pages/exhibition/exhibitDetail")
      },
      {
        name: "wenxing-pc-exhibition-exhibit-add",
        path: "/me/exhibition/exhibit/add",
        meta: {
          title: "个人中心-展品添加"
        },
        component: () => import("@wenxing/pages/exhibition/exhibitEdit")
      },
      {
        name: "wenxing-pc-exhibition-exhibit-edit",
        path: "/me/exhibition/exhibit/edit/:id",
        meta: {
          title: "个人中心-展品编辑"
        },
        component: () => import("@wenxing/pages/exhibition/exhibitEdit")
      },
      //商贸配对活动
      {
        name: "商贸配对活动",
        path: "/me/exhibition/tradeMatchingActivities/list",
        component: () =>
          import("@wenxing/pages/exhibition/tradeMatchingActivities/list.vue")
      },
      //商贸配对活动 已经选择
      {
        name: "商贸配对活动-已经选择",
        path: "/me/exhibition/tradeMatchingActivities/selectedlist",
        component: () =>
          import("@wenxing/pages/exhibition/tradeMatchingActivities/selectedlist.vue")
      },
      //商贸配对活动  等待选择
      {
        name: "商贸配对活动-等待选择",
        path: "/me/exhibition/tradeMatchingActivities/waitlist",
        component: () =>
          import("@wenxing/pages/exhibition/tradeMatchingActivities/waitlist.vue")
      },

    ]
  }
]



// WEBPACK FOOTER //
// ./src/wenxing/router/exhibitor/index.js